module.exports = __webpack_public_path__ + "img/filter.d730cd6d.svg";